@if (mainFilename$ | async; as mainFilename) {
  <tkv-angebot
    *axLazyElement="'tkv-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></tkv-angebot>
}
